var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticStyle:{"border-bottom":"1px solid #CCC","margin-bottom":"25px"}},[_vm._v("Помощь в работе с системой")]),_vm._v(" "),_c('BrowserNotifications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }